export function getWebadminBaseUrl(): string {
  return import.meta.env.MODE === "prod"
    ? "https://app.printtrackerpro.com"
    : "https://app.dev.printtrackerpro.com";
}
